// Deep-link helpers for the Conditions page.
//
// Anchor format:
//   #cond-{CODE}        → Conditions tab, expand condition CODE
//   #cat-{slug}         → Categories tab, expand the matching category
//
// The Conditions page uses the hash to drive both tab selection and
// expansion-on-load, so any of these URLs are sufficient on their own.

export function slugifyCategory(name: string): string {
  return name
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

export function conditionAnchor(code: string): string {
  return `cond-${code}`;
}

export function categoryAnchor(name: string): string {
  return `cat-${slugifyCategory(name)}`;
}

export function conditionHref(tenant: string, code: string): string {
  return `/${tenant}/conditions#${conditionAnchor(code)}`;
}

/**
 * Build a Sessions URL with filter query params preset. Pass only the
 * filters you want preselected; empty/undefined values are dropped.
 */
export function sessionsHref(
  tenant: string,
  query?: {
    title?: string;
    project?: string;
    user?: string;
    turns?: string;
    effort?: string;
    success?: string;
    issue?: string;
  },
): string {
  if (!query) return `/${tenant}/sessions`;
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(query)) {
    if (v) params.set(k, v);
  }
  const q = params.toString();
  return q ? `/${tenant}/sessions?${q}` : `/${tenant}/sessions`;
}

export interface ParsedAnchor {
  tab: "conditions" | "categories";
  target: string; // condition code, or category slug
}

export function parseAnchor(hash: string): ParsedAnchor | null {
  const h = hash.replace(/^#/, "");
  if (h.startsWith("cond-")) return { tab: "conditions", target: h.slice(5) };
  if (h.startsWith("cat-")) return { tab: "categories", target: h.slice(4) };
  return null;
}
